/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1PersonIdAddressesCopyToPaymentMutationResponse,
  PostApiV1PersonIdAddressesCopyToPaymentPathParams,
  PostApiV1PersonIdAddressesCopyToPayment401,
  PostApiV1PersonIdAddressesCopyToPayment404,
  PostApiV1PersonIdAddressesCopyToPayment500,
} from "../../types/personRegisterController/PostApiV1PersonIdAddressesCopyToPayment.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1PersonIdAddressesCopyToPayment } from "../../clients/personRegisterController/postApiV1PersonIdAddressesCopyToPayment.ts";

export const postApiV1PersonIdAddressesCopyToPaymentMutationKey = () =>
  [{ url: "/api/v1/person/:id/addresses/copy-to-payment" }] as const;

export type PostApiV1PersonIdAddressesCopyToPaymentMutationKey = ReturnType<
  typeof postApiV1PersonIdAddressesCopyToPaymentMutationKey
>;

export function postApiV1PersonIdAddressesCopyToPaymentMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = postApiV1PersonIdAddressesCopyToPaymentMutationKey();
  return mutationOptions<
    PostApiV1PersonIdAddressesCopyToPaymentMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdAddressesCopyToPayment401
      | PostApiV1PersonIdAddressesCopyToPayment404
      | PostApiV1PersonIdAddressesCopyToPayment500
    >,
    { id: PostApiV1PersonIdAddressesCopyToPaymentPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return postApiV1PersonIdAddressesCopyToPayment(id, config);
    },
  });
}

/**
 * @description Copia o endereço pessoal da pessoa para o endereço de pagamento (cria ou atualiza). **(Requer Authorization para autenticação)**
 * @summary Copiar endereço pessoal para pagamento (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/addresses/copy-to-payment}
 */
export function usePostApiV1PersonIdAddressesCopyToPayment<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1PersonIdAddressesCopyToPaymentMutationResponse,
      ResponseErrorConfig<
        | PostApiV1PersonIdAddressesCopyToPayment401
        | PostApiV1PersonIdAddressesCopyToPayment404
        | PostApiV1PersonIdAddressesCopyToPayment500
      >,
      { id: PostApiV1PersonIdAddressesCopyToPaymentPathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1PersonIdAddressesCopyToPaymentMutationKey();

  const baseOptions = postApiV1PersonIdAddressesCopyToPaymentMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1PersonIdAddressesCopyToPaymentMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdAddressesCopyToPayment401
      | PostApiV1PersonIdAddressesCopyToPayment404
      | PostApiV1PersonIdAddressesCopyToPayment500
    >,
    { id: PostApiV1PersonIdAddressesCopyToPaymentPathParams["id"] },
    TContext
  >;

  return useMutation<
    PostApiV1PersonIdAddressesCopyToPaymentMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdAddressesCopyToPayment401
      | PostApiV1PersonIdAddressesCopyToPayment404
      | PostApiV1PersonIdAddressesCopyToPayment500
    >,
    { id: PostApiV1PersonIdAddressesCopyToPaymentPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1PersonIdAddressesCopyToPaymentMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdAddressesCopyToPayment401
      | PostApiV1PersonIdAddressesCopyToPayment404
      | PostApiV1PersonIdAddressesCopyToPayment500
    >,
    { id: PostApiV1PersonIdAddressesCopyToPaymentPathParams["id"] },
    TContext
  >;
}
